import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import NewStudyGroupForm from "../../../components/Admin/StudyGroups/NewStudyGroupForm";
import actions from "actions";
import constants from "constants";
import validator from "services/validator";
import inputFormatter from "services/userInputFormatter";

const { CREATE_STUDY_GROUP_SAGA } = constants;

const {
  createStudygroup,
  cleanErrors,
  getSuperhosts,
  // adminUserFilter,
} = actions;

class NewStudyGroup extends Component {
  static propTypes = {
    createStudyGroup: PropTypes.func,
    cleanErrors: PropTypes.func,
    dispatch: PropTypes.func,
    errors: PropTypes.object,
    errorsFrontend: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      group: {
        title: "",
        superhost_ids: [],
        show_for_users: false,
        logo: null,
        logo_url: "",
        // member_ids: [],
      },
    };
  }

  componentWillMount() {
    this.props.cleanErrors();
    this.props.getSuperhosts({}, "all");
    // this.props.loadUsers({per_page: 'all'}, 'all');
  }

  onFieldChange = (e) => {
    const input = inputFormatter.formatField(e.target.name, e.target.value);
    const groupData = {
      ...this.state.group,
      ...{
        [e.target.name]: input,
      },
    };

    this.setState({ group: groupData });
  };

  handleShowChange = (value) =>
    this.setState({ group: { ...this.state.group, show_for_users: value } });

  onSubmit = () => {
    this.props.createStudyGroup(this.state.group);
  };

  handleFileChange = (file) =>
    this.setState({
      group: {
        ...this.state.group,
        logo: file,
        logo_url: URL.createObjectURL(file),
      },
    });

  onIdsChange = (roles) => {
    this.onFieldChange({
      target: {
        name: "superhost_ids",
        value: (roles || []).map((role) => role.value),
      },
    });
  };

  render() {
    const { errors, errorsFrontend, superhosts, members } = this.props;
    const superhostsOptions = (superhosts || []).map((superhost) => ({
      value: superhost.id,
      label: `${superhost.first_name} ${superhost.last_name}`,
    }));
    // const membersOptions = (members || []).map(member => ({value: member.id, label: member.full_name}))

    return (
      <main className="site--width clearfix-c">
        <NewStudyGroupForm
          onFieldChange={this.onFieldChange}
          group={this.state.group}
          onSubmit={this.onSubmit}
          superhosts={superhostsOptions}
          // members={membersOptions}
          errors={validator.formatErrors(errors, errorsFrontend)}
          handleShowChange={this.handleShowChange}
          handleFileChange={this.handleFileChange}
          onIdsChange={this.onIdsChange}
        />
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    errors: state.errors[CREATE_STUDY_GROUP_SAGA],
    errorsFrontend: state.errors[`${CREATE_STUDY_GROUP_SAGA}_FRONTEND`],
    superhosts: state.superhosts.superhosts.values,
    // members: state.users.adminUsers.values,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    createStudyGroup: (group) => dispatch(createStudygroup(group)),
    cleanErrors: () => dispatch(cleanErrors(CREATE_STUDY_GROUP_SAGA)),
    getSuperhosts: (query, page) => dispatch(getSuperhosts(query, page)),
    // loadUsers: (query, page, per_page) => dispatch(adminUserFilter(query, page, per_page)),
    dispatch: dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewStudyGroup);



// WEBPACK FOOTER //
// ./src/containers/Admin/StudyGroups/NewStudyGroup.jsx